import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IComboGroupContext, ComboGroupContext } from '../../../../comboGroupState/comboGroupContext';
import Item from './components/Item';
import classNames from 'classnames';
import style from './List.module.scss';

const List: React.FC = () => {
	const { comboGroups } = useContext<IComboGroupContext>(ComboGroupContext);

	const comboGroupHeadingClasses = classNames(style.comboGroup, style.heading);
	const restaurantHeadingClasses = classNames(style.restaurant, style.heading);
	const customerHeadingClasses = classNames(style.customer, style.heading);
	const positionHeadingClasses = classNames(style.position, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="List">
			<div className={style.tableHeaders}>
				<Text
					className={comboGroupHeadingClasses}
					translationNameSpace="listing"
					translationKey="comboGroupLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={restaurantHeadingClasses}
					translationNameSpace="listing"
					translationKey="restaurantLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={customerHeadingClasses}
					translationNameSpace="listing"
					translationKey="customerLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={positionHeadingClasses}
					translationNameSpace="listing"
					translationKey="positionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{comboGroups.comboGroups.map((item, index) => (
				<Item data={item} key={item.id} index={index} />
			))}
		</div>
	);
};

export default List;
